// Empfänger einer Antwort. „Allen antworten" nimmt die übrigen Empfänger der Ursprungsmail
// ins Cc — ohne das eigene Postfach (man schreibt sich nicht selbst) und ohne den Absender,
// der bereits im An steht. Reine Regel, damit sie testbar bleibt und nicht in der Maske hängt.

export interface AntwortQuelle {
  von: string;
  an?: string[] | null;
  cc?: string[] | null;
}

export interface AntwortEmpfaenger {
  an: string[];
  cc: string[];
}

/** Nackte Adresse aus „Name <mail@x.de>" — Graph liefert reine Adressen, Alt-/Fremddaten nicht immer. */
export function adresseAus(eintrag: string | null | undefined): string {
  const s = (eintrag || '').trim();
  const m = s.match(/<([^>]+)>/);
  return (m ? m[1] : s).trim();
}

const schluessel = (eintrag: string) => adresseAus(eintrag).toLowerCase();

export function antwortEmpfaenger(
  quelle: AntwortQuelle,
  eigeneAdresse: string,
  allen: boolean,
): AntwortEmpfaenger {
  const an = [quelle.von].filter((e) => adresseAus(e) !== '');
  if (!allen) return { an, cc: [] };

  const gesperrt = new Set([schluessel(quelle.von), schluessel(eigeneAdresse)].filter(Boolean));
  const cc: string[] = [];
  for (const eintrag of [...(quelle.an || []), ...(quelle.cc || [])]) {
    const k = schluessel(eintrag);
    if (!k || gesperrt.has(k)) continue;
    gesperrt.add(k); // zugleich Dublettenschutz
    cc.push(adresseAus(eintrag));
  }
  return { an, cc };
}
